import React, { useEffect, useState } from "react";
import CustomerProfile from "../customer-consent/components/CustomerProfile";
import Navbar from "../customer-consent/components/Navbar";
import { customer_consent_get_inspection_repair } from "../../API/api";
import customFetch from "../../API/CustomFetch";
import { DataItem } from "../customer-consent/datatype";

export const ViewInspection = () => {
  const [data, setData] = useState<DataItem[] | null>(null);
  const [formType, setFormType] = useState("");
  const [typeMasterId, setTypeMasterId] = useState<string | null>(null);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const type = urlParams.get("type");
    const vehicleProfileId = urlParams.get("vp");
    setTypeMasterId(type);
    const url = `${customer_consent_get_inspection_repair}/${vehicleProfileId}/${type}`;
    if (type && parseInt(type) === 53) {
      setFormType("Inspection Information");
    } else if (type && parseInt(type) === 54) {
      setFormType("Repair Criteria Information");
    } else if (type && parseInt(type) === 80) {
      setFormType("Final Inspection Report");
    }
    customFetch(url).then((res) => {
      if (res.SUCCESS) {
        let responseData = res.DATA;

        // normalize to array
        if (Array.isArray(responseData)) {
          setData(responseData);
        } else if (responseData && typeof responseData === "object") {
          setData([responseData]); // wrap single object into array
        } else {
          setData([]); // fallback
        }
      }
    });
  }, []);
  return (
    <div className="flex-col justify-self-center" id="pdf-content">
      <Navbar />
      <h1 className="text-2xl font-bold mb-4 text-center">{formType} </h1>
      <CustomerProfile typeMasterId={typeMasterId} />
      <div className="border border-gray-300 p-4">
        <h2 className="text-xl font-bold mb-4 justify-self-center">
          {" "}
          Report Details
        </h2>
        <table className="table-auto w-full">
          <thead>
            <tr>
              <th className="px-4 py-2">Question/Item</th>
              <th className="px-4 py-2">Response/Cost</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(data) &&
              data.map((item) =>
                item?.Question?.map((questionItem) => (
                  <tr key={questionItem.QuestionId}>
                    <td className="border px-4 py-2">
                      {questionItem.Question}
                    </td>
                    <td className="border px-4 py-2">
                      {questionItem.Response?.includes(".jpg") ? (
                        <img
                          className="max-h-screen"
                          src={questionItem.Response}
                          alt={questionItem.Question}
                        />
                      ) : (
                        questionItem.Response
                      )}
                    </td>
                  </tr>
                ))
              )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
